import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { OverlayModule } from '@angular/cdk/overlay';
import { SvgModule } from '@shared/components/svg/svg.module';
import { ReactiveFormsModule } from '@angular/forms';
import { NgLetModule } from '@shared/directives/ng-let/ng-let.module';
import { ButtonIconModule } from '@impairedShared/button-icon/button-icon.module';
import { ImpairedIconModule } from '@impairedShared/impaired-icon/impaired-icon.module';
import { SelectImpairedModule } from '@impairedShared/select-impaired/select-impaired.module';
import { PxModule } from '@shared/pipes/px/px.module';
import { MainComponent } from './components/main/main.component';
import { RoutingModule } from './routing.module';
import { HeaderComponent } from './components/header/header.component';
import { SettingStylesComponent } from './components/setting-styles/setting-styles.component';
import { TabComponent } from './components/tab/tab.component';
import { FooterComponent } from './components/footer/footer.component';
import { GlobalSearchComponent } from './components/global-search/global-search.component';

@NgModule({
  declarations: [MainComponent, HeaderComponent, SettingStylesComponent, TabComponent, FooterComponent, GlobalSearchComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RoutingModule,
    TranslateModule,
    ButtonIconModule,
    OverlayModule,
    SvgModule,
    NgLetModule,
    ImpairedIconModule,
    SelectImpairedModule,
    PxModule
  ],
  bootstrap: [MainComponent]
})
export class VersionForVisuallyImpairedModule {}
